/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

export default function DisplayErrorMessages(props) {
  const { errorMessages, addInLineCss } = props;
  const errorMsgRead = `frr-error-msg-read${uuidv4()}`;
  return (
    <div>
      {errorMessages.length > 0 ? (
        <div
          className="alert alert-danger custom-alert text-left"
          role="alert"
          aria-describedby={errorMsgRead}
          style={addInLineCss ? { wordWrap: 'break-word' } : {}}
        >
          <div id={errorMsgRead}>
            {errorMessages.map((message, index) => (
              <li key={index}>{message}</li>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}

DisplayErrorMessages.propTypes = {
  errorMessages: PropTypes.array.isRequired,
};
